<template>
  <v-flex align-center style="padding-right: 2px !important;"> 
    <v-btn
      v-if="showRemoveButton()"
      round
      icon
      color="primary"
      small
      class="ma-0"
      @click.stop="onRemove"
    >
      <v-icon small>remove</v-icon>
    </v-btn>
    <span
      v-if="showQuantity()"
      class="mx-2"
    >{{ quantity }}</span>
    <v-btn
      v-if="showAddButton()"
      :disabled="!canAdd || disabled"
      round
      :outline="!showQuantity()"
      icon
      :color="showQuantity() ? 'primary' : ''"
      small
      class="ma-0"
      @click.stop="onAdd"
    >
      <v-icon small>add</v-icon>
    </v-btn>
  </v-flex>
</template>
<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      minCardinality: {
        type: Number,
        default: 0
      },
      maxCardinality: {
        type: Number,
        default: 0
      },
      initQuantity: {
        type: Number,
        default: 0
      },
      maximumSelected: {
        type: Number,
        default: -1
      }
    },
    watch: {
      'initQuantity'() {
        this.quantity = this.initQuantity >= 0 ? this.initQuantity : 0
      }
    },
    mounted() {
      this.quantity = this.initQuantity >= 0 ? this.initQuantity : 0
    },
    data() {
      return {
        quantity: 0
      }
    },
    computed: {
      canAdd() {
        if (this.maximumSelected > 0 || this.maximumSelected === -1) {
          if (this.quantity < this.maxCardinality || this.maxCardinality === -1) {
            return true
          }
        }


        return false
      }
    },
    methods: {
      showQuantity() {
        return this.quantity > 0
      },
      showAddButton(){
        return true
      },
      showRemoveButton(){
        return this.quantity > 0
      },
      onRemove(){
        if (this.quantity > 0) {
          this.quantity -= 1
          this.emitQuantity()
        }
      },
      onAdd() {
        if (this.canAdd) {
          this.quantity += 1
          this.emitQuantity()
        }
      },
      emitQuantity() {
        this.$emit('change', this.quantity)
      }
    }
  }
</script>
